import React from "react"
import Section from "./section"
import DfbHeadline from "../ui-kit/dfb_headline"
import CCardCta from "../elements/c_card_cta"

const MCardGridCTA = ({ data }) => {
  const { headline, card_cta_item, layout } = data

  return (
    <Section
      baseClass="m-CardGrid m-CardGrid--cta"
      defaultPadding="large"
      data={data}
    >
      <div className="m-CardGrid-wrapper">
        <div className="m-CardGrid-container">
          {headline && (
            <DfbHeadline
              headline={headline}
              headline_level="h2"
              add_class="m-CardGrid-headline"
            />
          )}
        </div>
        <div className={`c-CardGrid c-CardGrid--cta ${layout === 'benefits-career' ? 'c-CardGrid--benefits' : ''}`}>
          <div className="c-CardGrid-container">
            {
              card_cta_item.map((item, index) => {
                // Add use_c_card_cta_item_structure to item to handle different structure from cms
                item.use_c_card_cta_item_structure = true
                return (
                  <div className="c-CardGrid-card" key={index}>
                    <CCardCta data={item} layout={layout} />
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardGridCTA
